import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-cream-100">
      {/* Navigation */}
      <nav className="border-b border-cream-300">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/assets/logo_2.png" alt="QuickSheet Logo" className="h-8 w-8" />
            <span className="font-bold text-xl text-navy-900">QuickSheet</span>
          </Link>
          <Link to="/" className="text-sm text-gray-500 hover:text-navy-900 transition">
            Back to home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-serif font-bold text-navy-900 mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-10">Last updated: February 16, 2026</p>

        <div className="space-y-8 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">1. Overview</h2>
            <p>
              QuickSheet ("we", "us", "our") is committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights regarding your information.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">2. Data We Collect</h2>
            <p className="mb-3">We collect the minimum data necessary to provide the Service:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
              <li><strong>Account information:</strong> Name, email address, and profile picture (if signing in with Google)</li>
              <li><strong>Cloud files:</strong> Spreadsheet files you explicitly choose to save to the cloud</li>
              <li><strong>Usage data:</strong> Basic analytics such as page views and feature usage to improve the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">3. Data We Do Not Collect</h2>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
              <li><strong>Local files:</strong> Files you open locally are processed entirely in your browser and are never sent to our servers</li>
              <li><strong>Spreadsheet contents:</strong> We do not read, analyze, or store the contents of your locally opened files</li>
              <li><strong>Tracking for ads:</strong> We do not use third-party advertising trackers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">4. How We Use Your Data</h2>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
              <li>To provide and maintain your account</li>
              <li>To store and sync your cloud files</li>
              <li>To improve the Service based on usage patterns</li>
              <li>To communicate important updates about the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">5. Data Storage &amp; Security</h2>
            <p>
              Cloud data is stored securely using Supabase infrastructure with encryption at rest and in transit. We use industry-standard security practices to protect your information. Only you can access your cloud-stored files.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">6. Third-Party Services</h2>
            <p className="mb-3">We use the following third-party services:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
              <li><strong>Supabase:</strong> Authentication and cloud file storage</li>
              <li><strong>Google OAuth:</strong> Optional sign-in via Google</li>
              <li><strong>Vercel:</strong> Hosting and deployment</li>
            </ul>
            <p className="mt-3">These services have their own privacy policies and we encourage you to review them.</p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">7. Cookies &amp; Local Storage</h2>
            <p>
              We use browser local storage to save your preferences (such as view settings and display options). We use essential cookies for authentication. We do not use cookies for advertising or cross-site tracking.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">8. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
              <li>Access the personal data we hold about you</li>
              <li>Delete your account and all associated cloud data</li>
              <li>Export your cloud-stored files at any time</li>
              <li>Opt out of non-essential communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">9. Children's Privacy</h2>
            <p>
              The Service is not intended for children under 13. We do not knowingly collect personal information from children under 13.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">10. Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of significant changes by posting a notice on the Service. Continued use after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">11. Contact</h2>
            <p>
              If you have questions about this privacy policy or your data, please reach out via the feedback button within the app.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
